import {
    MessageSquare,
    Paperclip,
    TrendingUp,
    DollarSign,
    Wallet,
    FileText,
    LucideIcon
} from 'lucide-react';

export const TIPOS_PENDENCIA = {
    CORRECAO: 'correcao',
    INFORMACAO: 'informacao',
    ORIENTACAO: 'orientacao',
    DOCUMENTACAO: 'documentacao',
    MAJORACAO: 'marjoracao',
    REEMBOLSO: 'reembolso',
    ADIANTAMENTO: 'adiantamento',
    SOLICITACAO_INFORMACAO: 's_informacao',
} as const;

export const TIPOS_PENDENCIA_LABELS: Record<string, string> = {
    [TIPOS_PENDENCIA.MAJORACAO]: 'Majoração',
    [TIPOS_PENDENCIA.SOLICITACAO_INFORMACAO]: 'Solicitação',
    [TIPOS_PENDENCIA.CORRECAO]: 'Correção',
    [TIPOS_PENDENCIA.INFORMACAO]: 'Informação',
    [TIPOS_PENDENCIA.ORIENTACAO]: 'Orientação',
    [TIPOS_PENDENCIA.DOCUMENTACAO]: 'Documentação',
    [TIPOS_PENDENCIA.REEMBOLSO]: 'Reembolso',
    [TIPOS_PENDENCIA.ADIANTAMENTO]: 'Adiantamento',
};

export const TIPOS_PENDENCIA_DESCRICOES: Record<string, string> = {
    [TIPOS_PENDENCIA.INFORMACAO]: 'Solicite informações específicas sobre a demanda ou processo.',
    [TIPOS_PENDENCIA.ORIENTACAO]: 'Solicite orientações sobre procedimentos ou dúvidas relacionadas à demanda.',
    [TIPOS_PENDENCIA.DOCUMENTACAO]: 'Solicite documentos necessários para o andamento da demanda.',
    [TIPOS_PENDENCIA.MAJORACAO]: 'Solicite aumento do valor profissional devido a alterações no escopo ou complexidade.',
    [TIPOS_PENDENCIA.REEMBOLSO]: 'Solicite reembolso de valores gastos com a demanda.',
    [TIPOS_PENDENCIA.ADIANTAMENTO]: 'Solicite adiantamento de valores antes da conclusão da demanda.',
    [TIPOS_PENDENCIA.CORRECAO]: 'Solicite correção de informações ou dados da demanda.',
};

export const TIPOS_PENDENCIA_LABELS_DESCRICAO: Record<string, string> = {
    [TIPOS_PENDENCIA.INFORMACAO]: 'Descrição da informação necessária',
    [TIPOS_PENDENCIA.ORIENTACAO]: 'Descrição da orientação necessária',
    [TIPOS_PENDENCIA.DOCUMENTACAO]: 'Descrição da documentação necessária',
    [TIPOS_PENDENCIA.MAJORACAO]: 'Descrição do motivo da majoração',
    [TIPOS_PENDENCIA.REEMBOLSO]: 'Descrição do motivo do reembolso',
    [TIPOS_PENDENCIA.ADIANTAMENTO]: 'Descrição do motivo do adiantamento',
    [TIPOS_PENDENCIA.CORRECAO]: 'Descrição da alteração necessária',
};

export const formatTipo = (tipo: string): string =>
    TIPOS_PENDENCIA_LABELS[tipo] ?? tipo;

export const getTipoIcon = (tipo: string): LucideIcon => {
    const tipoLower = tipo.toLowerCase();
    if (tipoLower === TIPOS_PENDENCIA.INFORMACAO || tipoLower === TIPOS_PENDENCIA.SOLICITACAO_INFORMACAO || tipoLower.includes('informação') || tipoLower.includes('instrução'))
        return MessageSquare;
    if (tipoLower === TIPOS_PENDENCIA.ORIENTACAO || tipoLower.includes('orientação'))
        return MessageSquare;
    if (tipoLower === TIPOS_PENDENCIA.DOCUMENTACAO || tipoLower.includes('documentação'))
        return Paperclip;
    if (tipoLower === TIPOS_PENDENCIA.MAJORACAO || tipoLower.includes('majoração'))
        return TrendingUp;
    if (tipoLower === TIPOS_PENDENCIA.REEMBOLSO)
        return DollarSign;
    if (tipoLower === TIPOS_PENDENCIA.ADIANTAMENTO)
        return Wallet;
    if (tipoLower === TIPOS_PENDENCIA.CORRECAO || tipoLower.includes('correção'))
        return FileText;
    return FileText;
};

export const isTipoFinanceiro = (tipo: string): boolean => {
    const tipoLower = tipo.toLowerCase();
    return tipoLower === TIPOS_PENDENCIA.MAJORACAO || tipoLower === TIPOS_PENDENCIA.REEMBOLSO || tipoLower === TIPOS_PENDENCIA.ADIANTAMENTO;
};

export const isTipoDocumentacao = (tipo: string): boolean =>
    tipo.toLowerCase() === TIPOS_PENDENCIA.DOCUMENTACAO;

export const isTipoInformativa = (tipo: string): boolean => {
    const tipoLower = tipo.toLowerCase();
    return tipoLower === TIPOS_PENDENCIA.INFORMACAO || tipoLower === TIPOS_PENDENCIA.ORIENTACAO || tipoLower === TIPOS_PENDENCIA.CORRECAO || tipoLower === TIPOS_PENDENCIA.SOLICITACAO_INFORMACAO;
};
